/* istanbul ignore file */
import { ComponentRef } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { SiteData } from '../../../../interfaces/site-data';
import { FieldIdentifier, LogicStyledGridRowCellDictionary, PointCategory, PresetStyleColorSelection } from '../../../../models';
import { MapFieldPoint } from '../../../../models/map-field-point';
import { FieldPointIconComponent } from '../../../../shared/components/field-point-icon/field-point-icon.component';

export class MapFieldPointLogicServiceModel {
    mapFieldPoint: MapFieldPoint;
    mapFieldPointAvailableColors: PresetStyleColorSelection[] = [];
    previewPointCategories: PointCategory[];
    form: UntypedFormGroup;
    formArray: UntypedFormArray = new UntypedFormArray([]);
    mapFieldPointSubmitted = false;
    rowCreatedId: string;
    fieldPointCluster: MarkerClusterer | null = null;
    fieldPointData: SiteData;
    fieldPointStyles: LogicStyledGridRowCellDictionary = new LogicStyledGridRowCellDictionary();
    fieldPointSettableFields: FieldIdentifier[] = [];
    categoryMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
    categoryMarkerBeingPreviewed: google.maps.marker.AdvancedMarkerElement;
    hiddenCategoryIds: Set<string> = new Set<string>();
    categoryMarkerComponentRefs: ComponentRef<FieldPointIconComponent>[] = [];
    isEditingFieldPointCoordinates = false;
    markerBeingEdited: google.maps.marker.AdvancedMarkerElement;
    previewFieldPointData: SiteData[] = [];
    rowToEditId: string;
    areMarkersFilteredInCluster = false;
}
